import algoliasearch from 'algoliasearch/lite';

import { ArticleSearchObject } from '../../../../../services/search/config/articles/types';
import { ProductSearchObject } from '../../../../../services/search/config/products/types';
import { ProviderSearchResults } from '../types';

const isArticleSearchObject = (
  searchResult: ArticleSearchObject | ProductSearchObject
): searchResult is ArticleSearchObject => searchResult.type === 'article';

const isProductSearchObject = (
  searchResult: ArticleSearchObject | ProductSearchObject
): searchResult is ProductSearchObject => searchResult.type === 'product';

export const executeSearch = async (
  searchQuery: string,
  locale: string
): Promise<ProviderSearchResults> => {
  const algoliaClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID as string,
    process.env.GATSBY_ALGOLIA_SEARCH_PUBLIC_KEY as string
  );

  const gatsbyAlgoliaIndex = algoliaClient.initIndex(
    process.env.GATSBY_ALGOLIA_INDEX!
  );

  const filter = { filters: `lang: ${locale}` };

  const searchResult = await gatsbyAlgoliaIndex.search<
    ArticleSearchObject | ProductSearchObject
  >(searchQuery, filter);

  const articles: Array<ArticleSearchObject> = [];
  const products: Array<ProductSearchObject> = [];

  searchResult?.hits.forEach((data) => {
    if (isArticleSearchObject(data)) {
      articles.push(data);
    }

    if (isProductSearchObject(data)) {
      products.push(data);
    }
  });

  return {
    articles,
    products,
  };
};
